import React, {useContext, useState} from 'react';
import {WAIT_LIST_ROUTE} from '../../util/constants';
import {login} from '../../util/requests';
import {AppContext} from '../context/appContext';
import {Navigate, useNavigate} from 'react-router';
import {ErrorType, showDialog, validateEmail} from '@dvrd/dvr-controls';
import {ResponseData} from '@dvrd/fetch';
import User from '../../models/userModel';
import LoginPage from './loginPage';

export default function LoginController() {
    const {user, onChangeContext} = useContext(AppContext);
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState<ErrorType>(null);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    if (!!user) return <Navigate to={WAIT_LIST_ROUTE}/>;

    function onChangeEmail(value: string) {
        setEmail(value);
    }

    function onChangePassword(value: string) {
        setPassword(value);
    }

    function onResetError() {
        setError(null);
    }

    function onSubmit() {
        if (!validateValues()) return;
        setLoading(true);
        login({
            data: {email, password}, callback: (data: ResponseData) => {
                setLoading(false);
                if (data.success) {
                    const user = new User(data.user);
                    onChangeContext({user});
                    navigate(WAIT_LIST_ROUTE);
                } else showDialog(data.message ?? 'Het inloggen is niet gelukt.', 'Inloggen mislukt');
            }
        });
    }

    function validateValues(): boolean {
        if (!email.length) {
            setError('Vul je e-mailadres in');
            return false;
        } else if (!validateEmail(email)) {
            setError('Vul een geldig e-mailadres in');
            return false;
        } else if (!password.length) {
            setError('Vul je wachtwoord in');
            return false;
        }
        return true;
    }

    return (
        <LoginPage onChangeEmail={onChangeEmail} onChangePassword={onChangePassword} onResetError={onResetError}
                   onSubmit={onSubmit} email={email} password={password} error={error} loading={loading}/>
    );
}

LoginController.displayName = 'LoginController';